import {combineReducers} from 'redux'
import {reducer as kandyReducer} from 'kandy-redux'
import agents from './agents'
import chatHistory from './chatHistory'
import currentAgent from './currentAgent'
import customers from './customers'
import dashboard from './dashboard'
import departments from './departments'
import notices from './notices'
import selectedCustomer from './selectedCustomer'
import serviceRequests from './serviceRequests'
import cannedMessages from './cannedMessages'
import video from './video'
import chatMessageHistory from './chatMessageHistory'
import chatMessageCall from './chatMessageCall'
import sessionTransfer from './sessionTransfer'
import currentCall from './currentCall'
import userRole from './userRole'
import safetyMechanism from './safetyMechanism'
//new reducers from chen
import policy from './policy'

const appReducer = combineReducers({
	agents,
	cannedMessages,
	chatHistory,
	currentAgent,
	customers,
	dashboard,
	departments,
	kandy: kandyReducer,
	notices,
	selectedCustomer,
	serviceRequests,
	video,
	chatMessageHistory,
	chatMessageCall,
	sessionTransfer,
	currentCall,
	userRole,
	safetyMechanism,
	policy,
})

export default appReducer
